module.exports = __webpack_public_path__ + "img/SHSYHYN.8ffef807.svg";